class HeaderScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.theme.safeZone = 500

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = window.theme.safeZone
    this.scrollDirection = ''

    this.setVariables()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.pastAnnouncement()

    this.setSize()
    this.setVisibility()

    if (this.externalEls?.collectionHeader?.exists) {
      this.handleCollectionHeader()
    }

    if (this.externalEls?.searchHeader?.exists) {
      this.handleSearchHeader()
    }

    if (this.externalEls?.wishlistHeader?.exists) {
      this.handleWishlistHeader()
    }

    this.setVariables()
  }

  pastAnnouncement () {
    const announcementSize = this.els?.announcement?.exists
      ? this.els.announcement.element.offsetHeight
      : 10

    document.body.classList.toggle(
      this.dataset.classSolid,
      this.lastKnownY > announcementSize,
    )
  }

  setSize () {
    document.body.classList.toggle(
      this.dataset.classScrolled,
      this.headerIsScrolled,
    )
  }

  setVisibility () {
    if (document.body.classList.contains('template-index')) {
      document.body.classList.toggle(
        !this.dataset.classHidden,
        this.shouldBeVisible,
      )
      return
    }

    document.body.classList.toggle(
      this.dataset.classHidden,
      !this.shouldBeVisible,
    )
  }

  setVariables () {
    setTimeout(() => {
      document.body.style.setProperty(
        '--Header_Bottom_Position',
        `${this.headerBottomPosition}px`,
      )
    }, 250)
  }

  handleCollectionHeader () {
    const headerStickyClass = 'lyt-Header-sticky'
    const headerHiddenClass = 'lyt-Header-hidden'
    const collectionStickyClass = 'clc-ProductGrid_HeaderContainer-sticky'
    const el = this.externalEls.collectionHeader.element
    const difference = (this.offsetHeight - this.collectionBodyPosition) * -1

    if (this.collectionBodyPosition <= this.offsetHeight) {
      if (this.hasMakersHero) {
        if (difference <= 0 && difference >= this.offsetHeight * 2) return

        this.style.top = `${difference}px`

        if (this.collectionBodyPosition <= 0) {
          el.style.top = 0

          document.body.classList.add(headerHiddenClass)
        } else {
          el.style.top = `${difference}px`

          document.body.classList.remove(headerHiddenClass)
        }

        document.body.classList.add(headerStickyClass)
      }

      el.classList.add(collectionStickyClass)
    } else {
      if (this.hasMakersHero) {
        this.style.top = 0

        document.body.classList.remove(headerStickyClass)
      }

      el.classList.remove(collectionStickyClass)
    }
  }

  handleSearchHeader () {
    const stickyClass = 'ku-ProductGrid_HeaderContainer-sticky'
    const el = this.externalEls.searchHeader.element

    if (this.searchBodyPosition <= this.offsetHeight) {
      el.classList.add(stickyClass)
    } else {
      el.classList.remove(stickyClass)
    }
  }

  handleWishlistHeader () {
    const stickyClass = 'ku-ProductGrid_HeaderContainer-sticky'
    const el = this.externalEls.wishlistHeader.element

    const thresholdAmount = 95

    if (this.wishlistBodyPosition <= thresholdAmount) {
      el.classList.add(stickyClass)
    } else {
      el.classList.remove(stickyClass)
    }
  }

  get shouldBeVisible () {
    if (this.hasMakersHero && this.scrollDirection === 'down') {
      const makersHero = this.externalEls.makersHero.element
      const brandsHeroHeight = Number(
        `-${makersHero.getBoundingClientRect().height}`,
      )

      if (
        makersHero.getBoundingClientRect().y - this.offsetHeight <
        brandsHeroHeight
      ) {
        return false
      } else {
        return true
      }
    }

    if (this.lastKnownY <= this.safeZone) {
      return true
    }

    if (
      this.hasMakersHero &&
      this.collectionBodyPosition >= this.offsetHeight
    ) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsScrolled () {
    return this.lastKnownY > this.offsetHeight + 40
  }

  get headerBottomPosition () {
    const position = this.getBoundingClientRect().bottom

    if (position < 0) return 0

    return position
  }

  get hasMakersHero () {
    return this.externalEls?.makersHero?.exists
  }

  get collectionBodyPosition () {
    return this.externalEls.collectionBody !== undefined
      ? this.externalEls.collectionBody.element.getBoundingClientRect().top
      : 0
  }

  get searchBodyPosition () {
    return this.externalEls?.searchBody.element.getBoundingClientRect().top
  }

  get wishlistBodyPosition () {
    return this.externalEls?.wishlistBody.element.getBoundingClientRect().top
  }
}

if (!customElements.get('header-scroll')) {
  customElements.define('header-scroll', HeaderScroll)
}
